import React from 'react'

import styled, { css, keyframes } from 'styled-components'

import CheckPaddedURL from 'assets/icons/check-padded.svg'
import Modal from 'components/Modal'
import ModalButtons from 'components/Modal/buttons'
import ModalTypography from 'components/Modal/typography'

import { theme } from '../../theme'
import CircleDashedURL from './assets/circle-dashed.svg'
import DocumentURL from './assets/document.svg'

interface IProps {
  completed: boolean
  onDoneClick: () => void
  isOpen: boolean
  onRequestClose: () => void
  progress: number
}

const LoadingIndicator = styled('div')<Pick<IProps, 'progress'>>`
  align-items: center;
  display: flex;
  height: 104px;
  justify-content: center;
  margin: 0 auto 20px;
  position: relative;
  width: 110px;

  svg {
    transform: rotate(-90deg);
  }

  circle {
    stroke-dasharray: 320;
    stroke-dashoffset: ${(props) => 320 * (1 - props.progress)};
    transition: stroke-dashoffset 300ms;
  }
`

const ModalMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`

const Label = styled.div`
  color: ${theme('colors.slate')};
  font-size: 22px;
  line-height: 1.36;
  text-align: center;
`

const Icon = styled.img`
  position: absolute;
`

const CheckPadded = styled.img`
  position: absolute;
  top: 5px;
  right: 5px;
`

const grow = keyframes`
  from {
    height: 34px;
  }
  to {
    height: 154px;
  }
`

const SuccessContainer = styled.div`
  ${css`
    animation: ${css`
      ${grow} 300ms ease-in-out
    `};
    overflow: hidden;
  `}
`

const StyledModal = styled(Modal)`
  @media screen and (max-height: 568px) {
    position: absolute;
    top: 20px;
  }
`

const ProgressModal: React.FC<IProps> = (props) => (
  <StyledModal
    isOpen={props.isOpen}
    closeOnOutsideClick={true}
    closeOnEsc={true}
    onRequestClose={props.onRequestClose}
  >
    {() => (
      <>
        <LoadingIndicator progress={props.progress}>
          <Icon src={CircleDashedURL} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="104"
            viewBox="0 0 104 104"
          >
            <circle
              cx="51"
              cy="51"
              r="51"
              fill="none"
              fillRule="evenodd"
              stroke="#74C947"
              strokeWidth="2"
              transform="translate(1 1)"
            />
          </svg>
          <Icon src={DocumentURL} />
          {props.progress === 1 && <CheckPadded src={CheckPaddedURL} />}
        </LoadingIndicator>

        {props.completed && props.progress === 1 ? (
          <>
            <SuccessContainer>
              <ModalMessage>
                <ModalTypography.Title>
                  Documents received
                </ModalTypography.Title>
                <ModalTypography.Body>
                  You've successfully uploaded your documents, they will now be
                  reviewed by our team.
                </ModalTypography.Body>
              </ModalMessage>
            </SuccessContainer>

            <ModalButtons.Row>
              <ModalButtons.Primary onClick={props.onDoneClick}>
                Ok
              </ModalButtons.Primary>
            </ModalButtons.Row>
          </>
        ) : (
          <Label>Uploading</Label>
        )}
      </>
    )}
  </StyledModal>
)

export default ProgressModal
